module.exports = __webpack_public_path__ + "img/logo.abf421a9.png";